<div
    class="input-group"
    *ngIf="property?.hide === false && !property?.showPopupButton"
>
    <mat-form-field
        [color]="property.isWarn ? 'warn' : 'primary'"
        *ngIf="property | isStringFilter"
        attr.data-cy="filter-input-string-{{ property.Key }}"
        [ngClass]="errorStateMatcher?.validationClass ?? 'valid'"
        [appearance]="appearance ?? 'fill'"
        [subscriptSizing]="subscriptSizing"
    >
        <mat-label *ngIf="property.displayKey">{{ property.Key }}</mat-label>
        <span
            matPrefix
            *ngIf="property.prefix"
            >{{ property.prefix }}</span
        >
        <span
            matPrefix
            *ngIf="property.hasIcon"
            ><i class="{{ property.iconClass }}"></i
        ></span>
        <input
            matInput
            [disabled]="disabled ? disabled : null"
            [(ngModel)]="property.Value"
            (ngModelChange)="errorStateMatcher?.markAsInteracted()"
            (blur)="errorStateMatcher?.markAsInteracted()"
            type="{{ inputType }}"
            id="{{ property.Key }}"
            placeholder="{{ property.placeholder }}"
            [errorStateMatcher]="errorStateMatcher"
        />
        <span
            matSuffix
            *ngIf="property.suffix"
            >{{ property.suffix }}</span
        >
        <mat-hint>{{ property.hint }}</mat-hint>
        <mat-error *ngIf="property.validationError">{{ property.validationError }}</mat-error>
    </mat-form-field>

    <ng-container *ngIf="property | isMultilineTextFilter">
        <app-multiline-text
            [property]="property"
            [appearance]="appearance"
            [showErrorsAfterInteraction]="showErrorsAfterInteraction"
            (valueChanged)="valueChanged.emit()"
            (keyDownEvent)="keyDownEvent.emit($event)"
        >
        </app-multiline-text>
    </ng-container>

    <mat-form-field
        [color]="property.isWarn ? 'warn' : 'primary'"
        [appearance]="appearance ?? 'fill'"
        *ngIf="property | isNumberFilter"
        attr.data-cy="filter-input-number-{{ property.Key }}"
        [ngClass]="errorStateMatcher?.validationClass ?? 'valid'"
        [subscriptSizing]="subscriptSizing"
    >
        <span
            matPrefix
            *ngIf="property.prefix"
            >{{ property.prefix }}</span
        >
        <span
            matPrefix
            *ngIf="property.hasIcon"
            ><i class="{{ property.iconClass }}"></i
        ></span>
        <mat-label *ngIf="property.displayKey">{{ property.Key }}</mat-label>
        <input
            matInput
            #inputFilter
            [disabled]="disabled ? disabled : null"
            [ngModel]="property.Value | string | noComma | number"
            [ngModelOptions]="{ updateOn: 'change' }"
            (ngModelChange)="property.Value = parseNumberValue($event); errorStateMatcher?.markAsInteracted()"
            (blur)="errorStateMatcher?.markAsInteracted()"
            type="text"
            [errorStateMatcher]="errorStateMatcher"
        />
        <span
            matSuffix
            *ngIf="property.suffix"
            >{{ property.suffix }}</span
        >

        <mat-hint>{{ property.hint }}</mat-hint>
        <mat-error *ngIf="property.validationError">{{ property.validationError }}</mat-error>
    </mat-form-field>

    <ng-container *ngIf="property | isBooleanFilter">
        <ng-container *ngIf="!property.isSlider">
            <mat-checkbox
                [(ngModel)]="property.Value"
                disabled="{{ property.isReadonly }}"
                (click)="$event.stopPropagation(); valueChanged.emit()"
                [matTooltipDisabled]="!property.isReadonly"
                [matTooltip]="property.disabledTooltip"
                matTooltipClass="tooltip"
            >
                {{ property.displayKey ? property.Key : '' }}</mat-checkbox
            >

            <mat-hint>{{ property.hint }}</mat-hint>
            <mat-error *ngIf="property.validationError">{{ property.validationError }}</mat-error>
        </ng-container>
        <ng-container *ngIf="property.isSlider">
            <mat-slide-toggle
                [(ngModel)]="property.Value"
                disabled="{{ property.isReadonly }}"
                [labelPosition]="property.labelPosition"
                [matTooltipDisabled]="!property.isReadonly"
                [matTooltip]="property.disabledTooltip"
                [hideIcon]="true"
                matTooltipClass="tooltip"
                [required]="property.isRequired"
            >
                {{ property.displayKey ? property.Key : '' }}</mat-slide-toggle
            >

            <mat-hint [ngStyle]="{ visibility: property.showHint ? 'visible' : 'hidden' }">
                {{ property.hint }}
            </mat-hint>

            <mat-error *ngIf="property.validationError">{{ property.validationError }}</mat-error>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="property | isDateFilter">
        <app-date-select
            [icon]="property.iconClass"
            [isEndDate]="property.isEndDate"
            [property]="property"
            [dateView]="property.view"
            [disabled]="disabled ? disabled : null"
            [appearance]="appearance"
            [showErrorsAfterInteraction]="showErrorsAfterInteraction"
            (valueChanged)="valueChanged.emit()"
        >
        </app-date-select>
    </ng-container>

    <ng-container *ngIf="property | isTimeFilter">
        <app-time-select
            [icon]="property.iconClass"
            [property]="property"
            [disabled]="disabled ? disabled : null"
            [val]="property.Value"
            [showErrorsAfterInteraction]="showErrorsAfterInteraction"
        >
        </app-time-select>
    </ng-container>

    <app-date-range-select
        *ngIf="property | isDateRangeFilter"
        [icon]="property.iconClass"
        [property]="property"
        [startDate]="property.Value?.startDate"
        [endDate]="property.Value?.endDate"
        [disabled]="disabled ? disabled : null"
        [appearance]="appearance"
        [showErrorsAfterInteraction]="showErrorsAfterInteraction"
        [compactDisplay]="compactDateRange"
    >
    </app-date-range-select>

    <app-autocomplete
        *ngIf="property | isAutocompleteFilter"
        [property]="property"
        [overrideDisabled]="overrideDisabled"
        [showErrorsAfterInteraction]="showErrorsAfterInteraction"
    >
    </app-autocomplete>

    <app-dropdown-filter
        *ngIf="
            (property | isGroupMultiselectFilter) ||
            (property | isGroupSelectFilter) ||
            (property | isMultiselectFilter) ||
            (property | isSelectFilter) ||
            (property | isPoliticalWindowsConfigTierFilter)
        "
        [overrideDisabled]="overrideDisabled"
        [disabledOptions]="disabledOptions"
        [hideOptions]="hideOptions"
        [preventTab]="preventTab"
        [collapsible]="collapsible"
        [property]="property"
        [appearance]="appearance"
        [showErrorsAfterInteraction]="showErrorsAfterInteraction"
        (filterRef)="filterRef.emit($event)"
        (optionDeleteButtonClicked)="optionDeleteButtonClicked.emit($event)"
        (valueChanged)="valueChanged.emit($event)"
        (keyDownEvent)="keyDownEvent.emit($event)"
    ></app-dropdown-filter>

    <div
        *ngIf="property | isRadioFilter"
        class="align-center"
    >
        <strong
            *ngIf="property.displayKey"
            class="has-text-right"
            >{{ property.displayKey ? property.Key + ':' : '' }}
        </strong>
        <span
            matPrefix
            *ngIf="property.isLoading"
            ><mat-spinner [diameter]="15"></mat-spinner
        ></span>
        <span
            matPrefix
            *ngIf="property.hasIcon && (property.isLoaded || !property.isAsync)"
            ><i class="{{ property.iconClass }}"></i
        ></span>
        <mat-radio-group
            attr.data-cy="filter-input-radio-{{ property.Key }}"
            id="{{ property.Key }}"
            [(ngModel)]="property.Value"
            [disabled]="disabled ? disabled : null"
            [required]="property.isRequired"
        >
            <div
                class="select-container"
                [class.vertical]="property.isVertical"
            >
                <mat-radio-button
                    (onSelectionChange)="selectionChange($event)"
                    attr.data-cy="filter-input-radio-option-{{ property.Key }}-{{ option }}"
                    *ngFor="let option of property.filteredOptions | async"
                    [value]="option"
                    [disabled]="disabledOptions?.includes(option)"
                >
                    {{ option | displayText }}
                </mat-radio-button>
            </div>
        </mat-radio-group>
        <mat-hint *ngIf="property.showHint">{{ property.hint }}</mat-hint>
        <mat-error *ngIf="property.validationError">{{ property.validationError }}</mat-error>
    </div>

    <div
        *ngIf="property | isCheckboxFilter"
        attr.data-cy="filter-input-checkbox-{{ property.Key }}"
        class="is-flex is-vcentered checkbox-filter"
    >
        <strong class="is-1 has-text-right">{{ property.displayKey ? property.Key + ':' : '' }}</strong>
        <span
            matPrefix
            *ngIf="property.isLoading"
            ><mat-spinner [diameter]="15"></mat-spinner
        ></span>
        <span
            matPrefix
            *ngIf="property.hasIcon && (property.isLoaded || !property.isAsync)"
            ><i class="{{ property.iconClass }}"></i
        ></span>
        <mat-checkbox
            *ngFor="let option of property.filteredOptions | async"
            attr.data-cy="filter-input-checkbox-option-{{ property.Key }}-{{ option }}"
            [(ngModel)]="option.included"
            (change)="valueChanged.emit()"
            [disabled]="disabled ? disabled : null"
            [required]="property.isRequired"
        >
            {{ option | displayText }}
        </mat-checkbox>
        <mat-hint>{{ property.hint }}</mat-hint>
        <mat-error *ngIf="property.validationError">{{ property.validationError }}</mat-error>
    </div>
</div>

<div
    class="input-group"
    attr.data-cy="filter-input-popup-button-{{ property.Key }}"
    *ngIf="property?.showPopupButton"
>
    <div
        class="button is-primary"
        [title]="property.buttonTitle"
        [attr.disabled]="property.buttonIsDisabled"
        (click)="property.buttonOnClick()"
    >
        {{ property.buttonLabel }}
    </div>
</div>
